export const menuData = [
  { name: 'WORK' },
  { name: 'SERVICES' },
  { name: 'ABOUT' },
  { name: 'INSIGHTS' },
  { name: 'CONTACT' }
]
